import { createReviewPublicService } from '@workpay/ds-shared/services/reviewPublicService';
import { publicClient } from '@lib/axios';

export const reviewService = createReviewPublicService(publicClient);
